import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'fig1.4', loadChildren: () => import('./chapter01/chapter01.module').then(m => m.Chapter01Module) },
  { path: 'fig2.1', loadChildren: () => import('./chapter02/chapter02.module').then(m => m.Chapter02Module) },

  { path: 'fig3.4', redirectTo: '/ch03/fig3.4', pathMatch: 'full' },
  { path: 'fig3.5', redirectTo: '/ch03/fig3.5', pathMatch: 'full' },

  { path: 'fig4.2', redirectTo: '/ch04/fig4.2', pathMatch: 'full' },
  { path: 'fig4.4', redirectTo: '/ch04/fig4.4', pathMatch: 'full' },
  { path: 'slide4.1', redirectTo: '/ch04/slide4.1', pathMatch: 'full' },

  { path: 'fig5.1', redirectTo: '/ch05/fig5.1', pathMatch: 'full' },
  { path: 'fig5.2', redirectTo: '/ch05/fig5.2', pathMatch: 'full' },
  { path: 'fig5.3', redirectTo: '/ch05/fig5.3', pathMatch: 'full' },
  { path: 'fig5.4', redirectTo: '/ch05/fig5.4', pathMatch: 'full' },
  { path: 'fig5.5', redirectTo: '/ch05/fig5.5', pathMatch: 'full' },
  { path: 'fig5a.2', redirectTo: '/ch05/fig5a.2', pathMatch: 'full' },

  { path: 'fig6.1', redirectTo: '/ch06/fig6.1', pathMatch: 'full' },
  { path: 'fig6.7', redirectTo: '/ch06/fig6.7', pathMatch: 'full' },
  { path: 'cc6.3.2', redirectTo: '/ch06/cc6.3.2', pathMatch: 'full' },

  { path: 'fig7.2', redirectTo: '/ch07/fig7.2', pathMatch: 'full' },
  { path: 'fig7.4', redirectTo: '/ch07/fig7.4', pathMatch: 'full' },
  { path: 'fig7.6', redirectTo: '/ch07/fig7.6', pathMatch: 'full' },
  { path: 'fig7.8', redirectTo: '/ch07/fig7.8', pathMatch: 'full' },

  { path: 'slide8.1', redirectTo: '/ch08/slide8.1', pathMatch: 'full' },
  { path: 'slide8.2', redirectTo: '/ch08/slide8.2', pathMatch: 'full' },

  { path: 'fig9.3', loadChildren: () => import('./chapter09/chapter09.module').then(m => m.Chapter09Module) },

  { path: 'fig10.6', redirectTo: '/ch10/fig10.6', pathMatch: 'full' },
  { path: 'fig10.7', redirectTo: '/ch10/fig10.7', pathMatch: 'full' },
  { path: 'fig10.8', redirectTo: '/ch10/fig10.8', pathMatch: 'full' },
  { path: 'fig10.9', redirectTo: '/ch10/fig10.9', pathMatch: 'full' },
  { path: 'fig10.10', redirectTo: '/ch10/fig10.10', pathMatch: 'full' },
  { path: 'fig10.11', redirectTo: '/ch10/fig10.11', pathMatch: 'full' },
  { path: 'fig10.12', redirectTo: '/ch10/fig10.12', pathMatch: 'full' },
  { path: 'fig10.13', redirectTo: '/ch10/fig10.13', pathMatch: 'full' },
  { path: 'fig10.14', redirectTo: '/ch10/fig10.14', pathMatch: 'full' },
  { path: 'fig10.14sbs', redirectTo: '/ch10/fig10.14sbs', pathMatch: 'full' },

  { path: 'ch11/fig11.2', redirectTo: '/ch11/fig11.2', pathMatch: 'full' },
  { path: 'ch11/fig11.3', redirectTo: '/ch11/fig11.3', pathMatch: 'full' },
  { path: 'ch11/fig11.4', redirectTo: '/ch11/fig11.4', pathMatch: 'full' },
  { path: 'ch11/fig11.5', redirectTo: '/ch11/fig11.5', pathMatch: 'full' },
  { path: 'ch11/fig11.6', redirectTo: '/ch11/fig11.6', pathMatch: 'full' },
  { path: 'ch11/fig11.7', redirectTo: '/ch11/fig11.7', pathMatch: 'full' },
  { path: 'ch11/fig11.9', redirectTo: '/ch11/fig11.9', pathMatch: 'full' },
  { path: 'ch11/fig11.10', redirectTo: '/ch11/fig11.10', pathMatch: 'full' },

  { path: 'fig12.2', redirectTo: '/ch12/fig12.2', pathMatch: 'full' },
  { path: 'fig12.4', redirectTo: '/ch12/fig12.4', pathMatch: 'full' },
  { path: 'fig12.5', redirectTo: '/ch12/fig12.5', pathMatch: 'full' },
  { path: 'fig12A.1', redirectTo: '/ch12/fig12A.1', pathMatch: 'full' },
  { path: 'fig12A.2', redirectTo: '/ch12/fig12A.2', pathMatch: 'full' },


  { path: 'fig13.1', redirectTo: '/ch13/fig13.1', pathMatch: 'full' },
  { path: 'fig13.2', redirectTo: '/ch13/fig13.2', pathMatch: 'full' },
  { path: 'fig13.3', redirectTo: '/ch13/fig13.3', pathMatch: 'full' },
  { path: 'fig13.4', redirectTo: '/ch13/fig13.4', pathMatch: 'full' },
  { path: 'fig13.5', redirectTo: '/ch13/fig13.5', pathMatch: 'full' },

  { path: 'fig14.5', redirectTo: '/ch14/fig14.5', pathMatch: 'full' },
  { path: 'fig14.6', redirectTo: '/ch14/fig14.6', pathMatch: 'full' },
  { path: 'fig14.8', redirectTo: '/ch14/fig14.8', pathMatch: 'full' },
  { path: 'fig14.9', redirectTo: '/ch14/fig14.9', pathMatch: 'full' },
  { path: 'fig14.10', redirectTo: '/ch14/fig14.10', pathMatch: 'full' },
  { path: 'slide14.1', redirectTo: '/ch14/slide14.1', pathMatch: 'full' },

  { path: 'slide15.1', loadChildren: () => import('./chapter15/chapter15.module').then(m => m.Chapter15Module) },

  { path: 'fig16.2', redirectTo: '/ch16/fig16.2', pathMatch: 'full' },
  { path: 'fig16.4', redirectTo: '/ch16/fig16.4', pathMatch: 'full' },

  { path: 'fig17.7', redirectTo: '/ch17/fig17.7', pathMatch: 'full' },
  { path: 'fig17.8', redirectTo: '/ch17/fig17.8', pathMatch: 'full' },
  { path: 'fig17.9', redirectTo: '/ch17/fig17.9', pathMatch: 'full' },

  { path: 'fig18.6', redirectTo: '/ch18/fig18.6', pathMatch: 'full' },
  { path: 'fig18.7', redirectTo: '/ch18/fig18.7', pathMatch: 'full' },
  { path: 'fig18.8', redirectTo: '/ch18/fig18.8', pathMatch: 'full' },
  { path: 'fig18.9', redirectTo: '/ch18/fig18.9', pathMatch: 'full' },

  { path: 'fig19.6', redirectTo: '/ch19/fig19.6', pathMatch: 'full' },
  { path: 'fig19.7', redirectTo: '/ch19/fig19.7', pathMatch: 'full' },
  { path: 'fig19.8', redirectTo: '/ch19/fig19.8', pathMatch: 'full' },
  { path: 'fig19.9', redirectTo: '/ch19/fig19.9', pathMatch: 'full' },
  { path: 'fig19.10', redirectTo: '/ch19/fig19.10', pathMatch: 'full' },
  { path: 'fig19.11', redirectTo: '/ch19/fig19.11', pathMatch: 'full' },
  { path: 'fig19.12', redirectTo: '/ch19/fig19.12', pathMatch: 'full' },

  { path: 'ch03/:id', loadChildren: () => import('./chapter03/chapter03.module').then(m => m.Chapter03Module) },
  { path: 'ch04/:id', loadChildren: () => import('./chapter04/chapter04.module').then(m => m.Chapter04Module) },
  { path: 'ch05/:id', loadChildren: () => import('./chapter05/chapter05.module').then(m => m.Chapter05Module) },
  { path: 'ch06/:id', loadChildren: () => import('./chapter06/chapter06.module').then(m => m.Chapter06Module) },
  { path: 'ch07/:id', loadChildren: () => import('./chapter07/chapter07.module').then(m => m.Chapter07Module) },
  { path: 'ch08/:id', loadChildren: () => import('./chapter08/chapter08.module').then(m => m.Chapter08Module) },
  { path: 'ch10/:id', loadChildren: () => import('./chapter10/chapter10.module').then(m => m.Chapter10Module) },
  { path: 'ch11/:id', loadChildren: () => import('./chapter11/chapter11.module').then(m => m.Chapter11Module) },
  { path: 'ch12/:id', loadChildren: () => import('./chapter12/chapter12.module').then(m => m.Chapter12Module) },
  { path: 'ch13/:id', loadChildren: () => import('./chapter13/chapter13.module').then(m => m.Chapter13Module) },
  { path: 'ch14/:id', loadChildren: () => import('./chapter14/chapter14.module').then(m => m.Chapter14Module) },
  { path: 'ch16/:id', loadChildren: () => import('./chapter16/chapter16.module').then(m => m.Chapter16Module) },
  { path: 'ch17/:id', loadChildren: () => import('./chapter17/chapter17.module').then(m => m.Chapter17Module) },
  { path: 'ch18/:id', loadChildren: () => import('./chapter18/chapter18.module').then(m => m.Chapter18Module) },
  { path: 'ch19/:id', loadChildren: () => import('./chapter19/chapter19.module').then(m => m.Chapter19Module) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
